import SectionDescriptionHome from './SectionDescriptionHome';
export default SectionDescriptionHome;
